import { matchPath } from 'react-router-dom';
import routesConfig from './routeConfig';

const ROUTE_TITLES = {
    '/admissions/students/select-student': {
        key: 'students',
        namespace: 'translation',
        fallback: 'Students',
    },
    '/admissions/students/add-students': {
        key: 'buttonLabel.addStudent',
        namespace: 'translation',
        fallback: 'Add Student',
    },
    '/financial-aid/single': {
        key: 'commonLabel.packagingSingle',
        namespace: 'financialAid',
        fallback: 'Packaging Single',
    },
    '/registration/academic/grades/grade-entry': {
        key: 'grade.gradeEntry',
        namespace: 'registration',
        fallback: 'Grade Entry',
    },
    '/registration/academic/grades/authportalgrade': {
        key: 'commonLabel.authorizePortalGrades',
        namespace: 'translation',
        fallback: 'Authorize Portal Grades',
    },
    '/billing/cashier-entry': {
        key: 'cashierEntry.cashierEntry',
        namespace: 'billing',
        fallback: 'Cashier Entry',
    },
};

const normalizePath = (pathname) => pathname.split(/[?#]/, 1)[0].replace(/\/+$/, '') || '/';

const getRegisteredRoute = (pathname) => routesConfig.find((route) => {
    if (!route.Layout || route.path === '*') {
        return false;
    }

    return matchPath(pathname, {
        path: route.path,
        exact: true,
        strict: false,
    });
});

const getPathTitle = (route) => route.path
    .split('/')
    .filter((segment) => segment && !segment.startsWith(':'))
    .map((segment) => segment
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .replace(/[-_]+/g, ' ')
        .replace(/\b\w/g, (letter) => letter.toUpperCase()))
    .join(' | ');

export const getStaffDocumentTitle = (pathname, t) => {
    const normalizedPath = normalizePath(pathname);
    const routeTitle = ROUTE_TITLES[normalizedPath.toLowerCase()];
    const registeredRoute = getRegisteredRoute(normalizedPath);
    const fallbackTitle = routeTitle?.fallback || (registeredRoute && getPathTitle(registeredRoute));
    const screenTitle = routeTitle
        ? t(routeTitle.key, { ns: routeTitle.namespace, defaultValue: routeTitle.fallback })
        : fallbackTitle;
    const safeScreenTitle = typeof screenTitle === 'string' && screenTitle.trim()
        ? screenTitle.trim()
        : fallbackTitle || 'Staff application';

    return `${safeScreenTitle} | Elements`;
};
